export const COLUMNSOBSERVACIONESOBJ = [
  {
    accessorKey: "id",
  },
  // {
  //   header: "Índice Mensual",
  //   accessorKey: "new_indicemensual",
  //   size: 50,
  //   minSize: 50,
  //   maxSize: 100,
  //   Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  // },
  {
    header: "Mes",
    accessorKey: "new_mes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Observación",
    accessorKey: "new_feedbacklider",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]

export const COLUMNSAVANCESOBJ = [
  {
    accessorKey: "id",
  },
  // {
  //   header: "Índice Mensual",
  //   accessorKey: "new_indicemensual",
  //   size: 50,
  //   minSize: 100,
  //   maxSize: 100,
  //   Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  // },
  {
    header: "Mes",
    accessorKey: "new_mes",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "% de Avance",
    accessorKey: "new_deavance",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]